enum RespTecDadosFranquia {
    Nenhum = 0,
    SomenteFranquia = 1,
    SomenteRespTec = 2,
    Ambos = 3,
    AmbosMesmaLinha = 4,
}

export default RespTecDadosFranquia;
